export default {
  title: 'Сheck your e-mail',
  subTitle: 'If the provided email address is in our database, we will send you an email to reset your password.',
};
